import { Transform } from 'class-transformer-global-storage';
// force lowercase 
export function ToLowerCase() {
  return Transform(({
    value
  }) => {
    if (typeof value === 'string') return value.toLowerCase();
    return value;
  });
}